import { Dialog, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import useModal from '../../hooks/use-modal.hook';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  modal: {
    '& .MuiDialogTitle-root': {
      padding: '11px 20px',
      color: theme.palette.secondary.main,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    '& .MuiDialogActions-root': {
      padding: ' 24px 20px',
      gap: 8,
    },
    '& .MuiDialogContent-root, & .MuiDialogTitle-root + .MuiDialogContent-root': {
      padding: ' 24px 20px',
      color: theme.palette.darkGray,
    },
  },
  backdrop: {
    backgroundColor: 'rgb(0 0 0 / 40%)',
  },
  paper: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    width: 440,
    minHeight: 173,
    maxHeight: 443,
  },
  // after paper, so it wins
  wide: {
    width: 600,
    maxHeight: '80vh',
  },
}));

interface Props {
  children: ReactNode;
  preventClose?: boolean;
  wide?: boolean;
}

export const Modal: FC<Props> = ({ children, preventClose = false, wide = false }) => {
  const { closeModal } = useModal();
  const handleClose = (_event: MouseEvent, reason: string) => {
    if (preventClose && reason === 'backdropClick') {
      return;
    }
    closeModal();
  };
  const styles = useStyles();

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      className={styles.modal}
      disableEscapeKeyDown={preventClose}
      PaperProps={{
        className: classNames(styles.paper, { [styles.wide]: wide }),
        elevation: 0,
        square: true,
      }}
      slotProps={{ backdrop: { className: styles.backdrop } }}
    >
      {children}
    </Dialog>
  );
};

export default Modal;
